import { gql } from '@apollo/client';

export const GET_ACCOUNT_STATS = gql`
  query AccountStat($input: AccountStatInput!) {
  accountStat(input: $input) {
    activeCategories
  }
}
`;
